export default __webpack_public_path__ + "static/media/logo_footer.5d8bebf3.png";